export default __webpack_public_path__ + "static/media/loader.77cea9b5.gif";